import React from 'react';
import { Pagination } from 'react-admin';

const NoPagination = props => <Pagination rowsPerPageOptions={[]} {...props} />

export default NoPagination;
